import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { Phone } from "lucide-react";

const About = () => {
  const team = [
    {
      name: "Eng. Mohamed Shoukry",
      role: "Co-Founder",
      position: "Budgeting and Reporting Manager at El-Sewedy Electric",
      phone: "01012345293",
    },
    {
      name: "Mr. Sayed Essam",
      role: "Co-Founder",
      position: "Senior Data Analyst at Schneider Electric",
      phone: "01111655799",
    },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header showSearch={false} />
      
      <main className="flex-grow">
        {/* Hero */}
        <section className="border-b border-border bg-secondary/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              About Fasttrack Hub
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl">
              Part of Fast Track Solutions, empowering project management professionals worldwide.
            </p>
          </div>
        </section>

        {/* Story */}
        <section className="py-12">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-foreground mb-4">Our Story</h2>
            <p className="text-muted-foreground leading-relaxed">
              At FAST TRACK SOLUTIONS, we provide integrated solutions that combine 
              strategic advisory, digital innovation, and professional development to 
              support contractors, suppliers, and enterprises across industries. Our offerings 
              include bid and business development consulting, AI-driven and Power Platform-based 
              digital transformation, and a specialized Learning Academy that merges project 
              management education with cutting-edge automation tools.
            </p>
          </div>
        </section>

        {/* Team */}
        <section className="py-12 bg-secondary/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-foreground mb-8 text-center">Our Team</h2>
            <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
              {team.map((member) => (
                <Card key={member.name} className="border-border">
                  <CardContent className="pt-6">
                    <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-lg font-bold mb-4">
                      {member.name.split(' ').slice(-1)[0][0]}
                    </div>
                    <h3 className="font-semibold text-foreground">{member.name}</h3>
                    <p className="text-primary text-sm mb-1">{member.role}</p>
                    <p className="text-muted-foreground text-sm mb-3">{member.position}</p>
                    <a 
                      href={`tel:+20${member.phone}`}
                      className="inline-flex items-center text-sm text-muted-foreground hover:text-primary"
                    >
                      <Phone className="w-4 h-4 mr-1" />
                      {member.phone}
                    </a>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
